import { Theme } from "@mui/material";

export const textStyle = (theme: Theme) => ({
  color: theme.palette.modalColors.colorLable,
});
